import React, { memo } from 'react'
import clsx from 'clsx'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Box, Typography } from '@mui/material'
import Rating from '@mui/material/Rating'
import GogleMapsIcon from 'components/icons/google-maps.svg'
import GogleMyBusinessIcon from 'components/icons/google-my-business-logo-letters.svg'

import sx from './styles'

const RatingCard = (props) => {
  const {
    variant = 'row', // column || row
    vtaVariant,
    rating = 0,
    text,
    textVariant = 'quote',
    sx: sxProp,
  } = props
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{ ...sx.root, ...sxProp }}
      className={clsx({ column: variant === 'column' })}
    >
      {
        vtaVariant
          ? (
            <>
              {isMobile && (
                <Box
                  sx={sx.contentRatingIcons}
                  mb={2}
                >
                  <Box>
                    <Typography
                      component="legend"
                      variant="h2"
                      sx={sx.ratingNumber}
                    >
                      {rating}
                      <Rating
                        value={rating}
                        precision={0.5}
                        readOnly
                        sx={sx.rating}
                      />
                    </Typography>
                  </Box>
                  <GogleMyBusinessIcon />
                  <GogleMapsIcon height={25} />
                </Box>
              )}

              <Typography
                variant={textVariant}
                sx={{ pr: 1 }}
                align={(variant === 'column' || isMobile) ? 'center' : 'left'}
              >
                {text}
              </Typography>

              {!isMobile && (
                <Box sx={sx.contentRatingIcons}>
                  <Box>
                    <Typography
                      component="legend"
                      variant="h2"
                      sx={sx.ratingNumber}
                    >
                      {rating}
                      <Rating
                        value={rating}
                        precision={0.5}
                        readOnly
                        sx={sx.rating}
                      />
                    </Typography>
                  </Box>
                  <GogleMapsIcon height={25} />
                </Box>
              )}
            </>
          )
          : (
            <>
              <Box
                sx={sx.contentRatingIcons}
              >
                <Box>
                  <Typography
                    component="legend"
                    variant="h2"
                    sx={sx.ratingNumber}
                  >
                    {rating}
                    <Rating
                      value={rating}
                      precision={0.5}
                      readOnly
                      sx={sx.rating}
                    />
                  </Typography>
                </Box>
                <GogleMapsIcon height={25} />
              </Box>

              <Typography
                variant={textVariant}
                sx={{ pr: 1 }}
                align={(variant === 'column' || isMobile) ? (textVariant ? 'left' : 'center') : 'left'}
              >
                {text}
              </Typography>
            </>
          )
      }

    </Box>
  )
}

export default memo(RatingCard)
